import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_accessories_hats: FaireCategoryEntity = {
  token: "cat_accessories-hats",
  type: "category",
  name: "Hats",
  level: 2,
  parentToken: "cat_accessories",
  href: "/category/accessories/hats",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
